<h3 mat-dialog-title style="width: 100%; text-align: center;">SSP Import</h3>
<div mat-dialog-content>
  <div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Project Name</mat-label>
        <input [(ngModel)]="projectName"  style="width: 100%;" matInput />
      </mat-form-field>
    </div>
    <div>
      <p>{{file?.name}}</p>
      <button mat-raised-button
              (click)="inputFile.click()"
              matTooltip="Accepted file: .xml">
        Select Document
      </button>
      <input #inputFile
             type="file"
             accept="application/xml"
             (change)="selectFile($event)"
             [style.display]="'none'">
    </div>

  </div>
</div>
<div mat-dialog-actions style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
  <button mat-raised-button [disabled]="!projectName || !file" (click)="import()">Ok</button>
  <button mat-raised-button (click)="onClose()">Cancel</button>
</div>
